export default {
  pageTitle: 'Factory Tour',
  metaDescription: 'Register for a Factory Tour at PT Tokki Engineering and Fabrication (TEF) and see our pressure vessel and heat exchanger production facility in Cikarang firsthand.',
  hero: {
    title: 'Factory Tour',
    subtitle: 'Visit our production facility and fabrication process in person',
  },
  intro: {
    heading: 'Visit the TEF Factory',
    description: 'PT Tokki Engineering and Fabrication welcomes students, universities, institutions, and business partners to see firsthand how we produce pressure vessels, heat exchangers, and specialized fabrication work. Register your visit using the form below.',
  },
  highlights: {
    schedule: { title: 'Visit Schedule', desc: 'Monday - Friday, during office operating hours' },
    advanceBooking: { title: 'Advance Booking', desc: 'Register at least 1 month before your preferred visit date' },
    groupSize: { title: 'Group Size', desc: 'Group visits of up to 40 participants per session' },
    freeOfCharge: { title: 'Safety Equipment', desc: 'Participants must bring their own safety shoes and safety helmet' },
  },
  terms: {
    heading: 'Terms & Conditions',
    items: [
      'Registration must be submitted at least 7 working days before the requested visit date.',
      'Participants must wear closed clothing and closed-toe shoes while in the production area for safety reasons.',
      'Our team will contact you by email/phone to confirm the schedule and visit details.',
      'PT TEF reserves the right to reschedule visits depending on factory operational conditions.',
      'Recording devices/cameras are not allowed in certain areas without written permission from TEF.',
    ],
  },
  form: {
    heading: 'Registration Form',
    subheading: 'Fill in the details below to request a factory tour visit',
    fullName: 'Full Name',
    institutionName: 'Institution / Company Name',
    email: 'Email',
    phoneNumber: 'Phone Number',
    participants: 'Number of Participants',
    preferredDate: 'Preferred Visit Date',
    purpose: 'Purpose / Additional Notes',
    purposePlaceholder: 'Tell us about the purpose of your visit...',
    submit: 'Submit Request',
    pleaseWait: 'Please Wait...',
    successMessage: 'Your factory tour request has been submitted. Our team will contact you shortly.',
    errorMessage: 'Failed to submit your request. Please try again.',
    requiredNotice: 'All fields marked with * are required',
  },
};
